import * as React from 'react'
import {
  IonContent,
  IonHeader,
  IonPage,
  IonSegment,
  IonSegmentButton,
} from '@ionic/react'

import CreateDynamicOutreachForm from '../../../components/outreach/create-dynamic-outreach-form'
import CreateOneTimeOutreachForm from '../../../components/outreach/create-onetime-outreach-form'
import AdminHeader from '../../../components/header/admin-header'

const segments = ['One Time', 'Dynamic'] as const
type Segment = typeof segments[number]

function CreateOutreach() {
  const [segment, setSegment] = React.useState<Segment>('One Time')

  return (
    <IonPage>
      <IonHeader>
        <AdminHeader title="New Outreach List" backRef="/admin/outreach" />
      </IonHeader>
      <IonContent className="ion-padding">
        <IonSegment
          value={segment}
          onIonChange={(e) => setSegment(e.detail.value as Segment)}
        >
          {segments.map((segment) => (
            <IonSegmentButton key={segment} value={segment}>
              {segment}
            </IonSegmentButton>
          ))}
        </IonSegment>

        {segment === 'One Time' ? <CreateOneTimeOutreachForm /> : null}

        {segment === 'Dynamic' ? <CreateDynamicOutreachForm /> : null}
      </IonContent>
    </IonPage>
  )
}

export default CreateOutreach
